import BuilderModel from "./builderModel";
import Certificate from "../../../formability/certificateBuilder/models/certificate";

export default class CertificateBuilderModel extends BuilderModel {
  certificate: Certificate;
  except = ['createEmbeddedObject'];
}
